class DescriptionTabs extends HTMLElement {
  connectedCallback() {
    if (this.initialized) return;
    this.initialized = true;

    // get all tabs
    this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
    this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));
    this.prevBtn = this.querySelector(".prev-btn");
    this.nextBtn = this.querySelector(".next-btn");

    if (!this.tabs.length) return;

    // loop through all tabs
    this.tabs?.forEach((tab, index) => {
      // work for each tab
      tab.addEventListener("click", () => this.selectTab(index));
      tab.addEventListener("keydown", (event) => this.onTabKeydown(event, index));
    });

    this.prevBtn?.addEventListener("click", () => {
      this.selectTab(this.activeIndex - 1);
    });
    this.nextBtn?.addEventListener("click", () => {
      this.selectTab(this.activeIndex + 1);
    });

    const initial = Math.max(
      0,
      this.tabs.findIndex((tab) => tab.getAttribute("aria-selected") === "true")
    );
    this.selectTab(initial, { focus: false, scroll: false });
  }

  get activeIndex() {
    return this.tabs.findIndex((tab) => tab.getAttribute("aria-selected") === "true");
  }

  selectTab(index, { focus = true, scroll = true } = {}) {
    if (index < 0 || index >= this.tabs.length) return;

    this.tabs.forEach((tab, i) => {
      const selected = i === index;
      // add active class / remove from all other tabs
      tab.classList.toggle("active", selected);
      tab.setAttribute("aria-selected", selected ? "true" : "false");
      tab.tabIndex = selected ? 0 : -1;
    });

    // get tabContent, add active, remove from all others contents
    this.panels.forEach((panel, i) => {
      const selected = i === index;
      panel.classList.toggle("active", selected);
      panel.hidden = !selected;
      panel.setAttribute("aria-hidden", selected ? "false" : "true");
      if (selected) {
        panel.setAttribute("tabindex", "0");
      } else {
        panel.removeAttribute("tabindex");
      }
    });

    if (scroll) {
      this.tabs[index].scrollIntoView({
        behavior: "smooth",
        inline: "center",
        block: "nearest",
      });
    }
    if (focus) this.tabs[index].focus();

    if (this.prevBtn) this.prevBtn.disabled = index <= 0;
    if (this.nextBtn) this.nextBtn.disabled = index >= this.tabs.length - 1;
  }

  onTabKeydown(event, index) {
    let nextIndex = null;

    switch (event.key) {
      case "ArrowRight":
      case "ArrowDown":
        nextIndex = (index + 1) % this.tabs.length;
        break;
      case "ArrowLeft":
      case "ArrowUp":
        nextIndex = (index - 1 + this.tabs.length) % this.tabs.length;
        break;
      case "Home":
        nextIndex = 0;
        break;
      case "End":
        nextIndex = this.tabs.length - 1;
        break;
      default:
        return;
    }

    event.preventDefault();
    this.selectTab(nextIndex);
  }

  handleTabClick() {}
}

// define
if (!customElements.get("description-tabs")) {
  customElements.define("description-tabs", DescriptionTabs);
}

let slickBlur = `linear-gradient(
  270deg,
  #fdfbf3 0%,
  #fdfbf3 26%,
  rgba(253, 251, 243, 0.95) 39.5%,
  rgba(253, 251, 243, 0) 100%
)`;

// $(".description__tabs").slick({
//   dots: false,
//   arrows:true,
//   infinite: false,
//   speed: 300,
//   slidesToScroll: 1,
//   slidesToShow: 1,
//   variableWidth: true,
//   prevArrow: $('.prev-btn'),
//   nextArrow: $('.next-btn'),
//   focusOnSelect: false,
//   responsive: [

//     // {
//     //   breakpoint: 1250,
//     //   settings: {
//     //     slidesToShow: 3,
//     //   }
//     // },
//     // {
//     //   breakpoint: 850,
//     //   settings: {
//     //     slidesToShow: 2,
//     //   },
//     // }
//   ],
// });
let slickList = document.querySelector(".description__tabs.slick-slider")?.firstElementChild;
$(".description__tabs").on("afterChange", function (event, slick, currentSlide) {
  // Add the style only to the last slide
  let nextBtn = document.querySelector(".description__tabs-wrapper .next-btn");
  if (nextBtn?.classList.contains("slick-disabled")) {
    slickList?.style.setProperty("--slick-blur", "transparent");
  } else {
    slickList?.style.setProperty("--slick-blur", slickBlur);
  }
});
